export default __webpack_public_path__ + "static/media/Circly_List_Deletion_2.bab5e72e.gif";